import { Remove } from "../utilities/DataTools";
import React from "react";
import { DraftImageSubject, ImageSubjectUtilities, PersonPosition } from '../utilities/ImageSubjectUtilities';
import { AnnotateImageProps, AnnotateImageState, AnnotateImage } from './AnnotateImage';

export class PeopleUpdater {

    actionPeopleGetter: (act: (subjects: DraftImageSubject[]) => void) => void;
    actInPlacePeopleGetter: (act: (subjects: DraftImageSubject[]) => void) => void;

    constructor(actionPeopleGetter: (act: (subjects:DraftImageSubject[]) => void) => void, actInPlacePeopleGetter: (act: (subjects:DraftImageSubject[]) => void) => void) {
        this.actionPeopleGetter = actionPeopleGetter;
        this.actInPlacePeopleGetter = actInPlacePeopleGetter;
    }

    act(action: (people: DraftImageSubject[]) => void) {
        this.actionPeopleGetter(action);
        // this.peopleControl.setState(prev => {
        //     const newState = structuredClone(prev);
        //     action(newState.people);
        //     return newState;
        // });
    }

    actInPlace(action: (people: DraftImageSubject[]) => void) {
        this.actInPlacePeopleGetter(action);
        // this.peopleControl.setState(prev => {
        //     action(prev.people);
        //     return prev;
        // });
    }

    addRowBack() {
        this.act(people => {
            people.push(...AnnotateImage.newRow(ImageSubjectUtilities.maxRow(people) + 1, 5));
        });
    }
    addRowFront() {
        this.act(people => {
            people.filter(p => p.row > 0).forEach(p => p.row = p.row + 1);
            people.push(...AnnotateImage.newRow(1, 5));
        });
    }
    addToRow(row: number) {
        this.act(people => {
            people.push(new DraftImageSubject(row, ImageSubjectUtilities.maxCol(people, row) + 1, "Player"));
        });
    }
    remove(pos: PersonPosition) {
        this.act(people => {
            Remove(people, p => p.row === pos.row && p.column === pos.column);
            people.filter(p => p.row === pos.row && p.column > pos.column).forEach(p => p.column--);
        });
    }

    updateName(pos: PersonPosition, name: string) {
        this.actInPlace(people => {
            const person = people.find(p => p.row === pos.row && p.column === pos.column);
            if (person != null) {
                person.name = name;
            }
        });
    }
    updateRole(pos: PersonPosition, role: string) {
        this.actInPlace(people => {
            const person = people.find(p => p.row === pos.row && p.column === pos.column);
            if (person != null) {
                person.role = role;
            }
        });
    }
}
